import React, { useEffect, useCallback, useRef } from 'react';
import { getAssetPath } from '../utils/paths';

const Hero = ({ onShowComingSoon }) => {
  const isProcessing = useRef(false);
  
  const handleLaunchApp = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (isProcessing.current) {
      return;
    }
    
    if (onShowComingSoon) {
      isProcessing.current = true;
      onShowComingSoon();
      setTimeout(() => {
        isProcessing.current = false;
      }, 500);
    }
  }, [onShowComingSoon]);
  useEffect(() => {
    // Typewriter effect initialization - prevent conflicts with jQuery
    const typewriterElements = document.querySelectorAll('.xb-item--text');
    if (typewriterElements.length > 0 && !window.typewriterInitialized) {
      window.typewriterInitialized = true;
      let currentIndex = 0;
      const interval = setInterval(() => {
        const elements = document.querySelectorAll('.xb-item--text');
        if (elements.length === 0) {
          clearInterval(interval);
          window.typewriterInitialized = false;
          return;
        }
        elements.forEach((el, index) => {
          el.classList.toggle('is-active', index === currentIndex);
        });
        currentIndex = (currentIndex + 1) % elements.length;
      }, 3000);
      return () => {
        clearInterval(interval);
        window.typewriterInitialized = false;
      };
    }
  }, []);

  return (
    <section className="hero hero-style-two pos-rel pb-55">
      <div
        className="hero-bg wow fadeInUp"
        data-wow-delay="500ms"
        data-wow-duration=".5s"
        style={{ backgroundImage: `url(${getAssetPath('/Helax/assets/img/bg/hero_bg.png')})` } }
      ></div>
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div className="col-lg-10">
            <div className="hero__content style-3 text-center">
              <h1 className="title wow fadeInUp" data-wow-delay="0ms" data-wow-duration=".5s">
                Trade smarter , contribute to Solana , The Nova Verse Way
                <span className="xb-title--typewriter" data-react-managed="true">
                  <span className="xb-item--text is-active">transaction</span>
                  <span className="xb-item--text">contribute</span>
                  <span className="xb-item--text">earn</span>
                </span>
              </h1>
          
              <p className="mb-30 wow fadeInUp" data-wow-delay="200ms" data-wow-duration=".5s">
              Support the Solana community with every transaction, make purposeful transactions just like Nova Verse
              </p>
              <div className="btns wow fadeInUp" data-wow-delay="300ms" data-wow-duration=".5s">
                <a className="thm-btn thm-btn--gradient style-2" href="#!" onClick={handleLaunchApp}>Launch App</a>
                
              </div>
              <div className="hero-image mt-90 wow fadeInUp" data-wow-delay="400ms" data-wow-duration=".5s">
                <img src={getAssetPath('/Helax/assets/img/shape/main.png')} alt="CRM Dashboard" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="crm-hero__shape">
        <div className="shape shape--1" data-parallax='{"y" : 80}'>
          <img className="wow fadeInLeft" src={getAssetPath('/Helax/assets/img/shape/h_shape6.png')} alt="" />
        </div>
        <div className="shape shape--2">
          <img src={getAssetPath('/Helax/assets/img/shape/h_shape7.png')} alt="" />
        </div>
        <div className="shape shape--3" data-parallax='{"y" : 70}'>
          <img className="wow fadeInRight" src={getAssetPath('/Helax/assets/img/shape/h_shape8.png')} alt="" />
        </div>
        <div className="shape shape--4">
          <img src={getAssetPath('/Helax/assets/img/shape/h_shape9.png')} alt="" />
        </div>
      </div>
    </section>
  );
};

export default Hero;

